export const baseText={
    more:'بیشتر',
    sort:'مرتب سازی بر اساس',
    new:'جدیدترین‌ها',
    mostview:'‌پربازدیدترین‌ها',
    mostsale:'پرفروشترین‌ها',
    cheapest:'ارزانترین‌ها',
    expensive:'گرانترین‌ها',
    notfind:'محصولی برای نمایش نیست',
    openDesc:'ادامه مطلب',
    closeDesc:'بستن',
    suggest:'پیشنهادات ویژه',
    blog:'مجله لوکسین لوکس',
    categories:'دسته بندی',
    allCategories: 'دسته بندی کالا ها',
    all:'مشاهده تمامی محصولات',
    cancel:'انصراف',
    search:"جستجو‌ی محصول یا برند",
    notmatch:'موردی یافت نشد',
    app:' با اپلیکیشن لوکسین لوکس می توانید در میان موج عظیمی از محصولات لوکس به گشت و گذار بپردازید و زودتر از بقیه از تخفیفات و محصولات جدید با خبر شوید.'
}